import * as React from 'react'
import {Section, Container} from '.'

export interface PaginationData {
    currentPage: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
}

export interface PaginationProps {
    pagination: PaginationData
    activeFilter: string | undefined
    paramName: string
    onPageChange: (page: number) => void
}

function buildUrl(paramName: string, filter: string | undefined, page: number): string {
    const params: string[] = []
    if (filter) {
        params[params.length] = paramName + '=' + encodeURIComponent(filter)
    }
    if (page > 1) {
        params[params.length] = 'side=' + page
    }
    return params.length > 0 ? '?' + params.join('&') : '?'
}

export const Pagination = (props: PaginationProps) => {
    const {pagination, activeFilter, paramName, onPageChange} = props

    if (pagination.totalPages <= 1) {
        return null
    }

    const handleClick = (page: number) =>
        (event: React.MouseEvent<HTMLAnchorElement>) => {
            event.preventDefault()
            onPageChange(page)
        }

    return (
        <Section padding="sm">
            <Container>
                <nav
                    className="col-span-full flex items-center justify-center gap-6"
                    aria-label="Paginering"
                >
                    {pagination.hasPrev && (
                        <a
                            href={buildUrl(paramName, activeFilter, pagination.currentPage - 1)}
                            onClick={handleClick(pagination.currentPage - 1)}
                            className="text-lg text-black underline"
                        >
                            Forrige
                        </a>
                    )}
                    <span className="text-sm text-slate-900">
                        Side {pagination.currentPage} av {pagination.totalPages}
                    </span>
                    {pagination.hasNext && (
                        <a
                            href={buildUrl(paramName, activeFilter, pagination.currentPage + 1)}
                            onClick={handleClick(pagination.currentPage + 1)}
                            className="text-lg text-black underline"
                        >
                            Neste
                        </a>
                    )}
                </nav>
            </Container>
        </Section>
    )
}
